import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  return (
    <div className="footer-container-main">
      <div className="footer-holder">
        <div className="footer-icons">
          <div className="footer-icon">
            <Link to="/">
              <img
                src={
                  location.pathname === "/"
                    ? "/images/footer-home-1.png"
                    : "/images/footer-home.svg"
                }
                className="img-fluid"
                alt="LG"
              />
            </Link>
          </div>
          <div className="footer-icon">
            <Link to="/profile">
              <img
                src={
                  location.pathname === "/profile"
                    ? "/images/footer-user-1.png"
                    : "/images/footer-user.svg"
                }
                className="img-fluid"
                alt="LG"
              />
            </Link>
          </div>
          <div className="footer-icon">
            <Link to="/promotion">
              <img
                src={
                  location.pathname === "/promotion"
                    ? "/images/footer-promotion-1.png"
                    : "/images/footer-promotion.svg"
                }
                className="img-fluid"
                alt="LG"
              />
            </Link>
          </div>
          <div className="footer-icon">
            <Link to="/chat">
              <img
                src={
                  location.pathname === "/chat"
                    ? "/images/footer-chat-1.png"
                    : "/images/footer-chat.svg"
                }
                className="img-fluid"
                alt="LG"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
